import React from 'react';
import PropTypes from 'prop-types';
import { Link, Route } from 'react-router-dom';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { combineClassNames } from 'core/css';

class FeaturesHeader extends React.Component {
  render() {
    const {
      returnUrl,
      returnHref,
      backText,
      headerText,
      trimsPath,
      capabilitiesPath,
      disableCapabilities
    } = this.props;

    return (
      <div className="features-header">
        {returnHref ? (
          <a
            href={returnHref}
            className="features-header__back-link stat-text-link"
            data-dtm="compare trims">
            <SvgIcon
              name="arrow-left"
              className="features-header__back-link-indicator"
            />
            {backText}
          </a>
        ) : (
          <Link
            to={returnUrl}
            className="features-header__back-link stat-text-link"
            data-dtm="compare trims">
            <SvgIcon
              name="arrow-left"
              className="features-header__back-link-indicator"
            />
            {backText}
          </Link>
        )}

        <div className="features-header__title">{headerText}</div>
        <div className="features-header__tabs">
          <Route path={trimsPath}>
            {({ match, location }) => (
              <Link
                to={`${trimsPath}/table${location.search}`}
                className={combineClassNames([
                  'features-header__tab stat-text-link',
                  match ? 'features-header__tab--active' : ''
                ])}
                data-dtm="compares trims">
                <Translate value="features.features" />
              </Link>
            )}
          </Route>
          {!disableCapabilities && (
            <Route path={capabilitiesPath}>
              {({ match, location }) => (
                <Link
                  to={`${capabilitiesPath}/table${location.search}`}
                  className={combineClassNames([
                    'features-header__tab stat-text-link',
                    match ? 'features-header__tab--active' : ''
                  ])}
                  data-dtm="compare capabilities">
                  <Translate value="features.capabilities" />
                </Link>
              )}
            </Route>
          )}
        </div>
      </div>
    );
  }
}

FeaturesHeader.propTypes = {
  returnUrl: PropTypes.string,
  returnHref: PropTypes.string,
  backText: PropTypes.node,
  headerText: PropTypes.node,
  trimsState: PropTypes.string,
  capabilitiesState: PropTypes.string,
  disableCapabilities: PropTypes.bool
};

export default FeaturesHeader;
